export const addCacheBusting = (url: string, timestamp: string | Date): string => {
  const cacheVersion = new Date(timestamp).getTime();
  return `${url}?v=${cacheVersion}`;
};
